/**
 * Centralized help content for the privacy module
 * Used by tooltips, info banners, and other contextual help throughout the UI
 */

export const PRIVACY_HELP = {
  // Jurisdiction explanations with deadline info
  jurisdiction: {
    ccpa: 'California Consumer Privacy Act - 45 day response deadline',
    gdpr: 'General Data Protection Regulation - 1 month response deadline',
    other: 'Other regulations - 45 day default deadline',
  },

  // Due date explanation
  dueDate: {
    general: 'Auto-calculated based on jurisdiction: CCPA = 45 days, GDPR = 1 month from received date',
    ccpa: '45 days from received date (CCPA)',
    gdpr: '1 month from received date (GDPR)',
    other: '45 days from received date',
  },

  // Verification status explanations
  verification: {
    pending: 'Identity not yet verified - verification required before completing request',
    verified: 'Identity confirmed - request can be processed',
    failed: 'Verification failed - may need to deny or request additional information',
    howTo: 'Update via Edit form or API: PATCH /v1/privacy/{id} with verification_status',
  },

  // Request status workflow explanations
  status: {
    received: 'New request - awaiting processing',
    in_progress: 'Being actively processed by team',
    completed: 'Request fulfilled - all obligations met',
    denied: 'Request rejected (document reason in notes)',
    workflow: 'Received → In Progress → Completed/Denied',
  },

  // Request type explanations
  requestTypes: {
    general: 'Types of privacy actions requested by the subject',
    opt_out_sale: 'Stop selling personal data to third parties (CCPA right)',
    opt_out_share: 'Stop sharing data for cross-context advertising',
    remove_data: 'Delete/erase all personal data from systems',
    do_not_contact: 'Exclude from all marketing communications',
  },

  // Stats page metric explanations
  stats: {
    dueSoon: 'Requests with due dates within the next 7 days',
    overdue: 'Requests past their compliance deadline',
    pendingVerification: 'Requests awaiting identity verification',
  },
}

/**
 * Get due date explanation based on jurisdiction
 */
export function getDueDateHelp(jurisdiction: string): string {
  switch (jurisdiction) {
    case 'ccpa':
      return PRIVACY_HELP.dueDate.ccpa
    case 'gdpr':
      return PRIVACY_HELP.dueDate.gdpr
    default:
      return PRIVACY_HELP.dueDate.other
  }
}

/**
 * Get jurisdiction explanation with deadline
 */
export function getJurisdictionHelp(jurisdiction: string): string {
  return PRIVACY_HELP.jurisdiction[jurisdiction as keyof typeof PRIVACY_HELP.jurisdiction]
    || PRIVACY_HELP.jurisdiction.other
}
